import { GitBranch } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EmptyState from "../components/ui/EmptyState";

const ValidationWorkflow = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold" style={{ color: "var(--lm-ink)" }}>
          {t("miscPages.validationWorkflow.title")}
        </h1>
        <p className="mt-1 text-sm" style={{ color: "var(--lm-ink-2)" }}>
          {t("miscPages.validationWorkflow.subtitle")}
        </p>
      </div>

      <EmptyState
        icon={GitBranch}
        title={t("miscPages.validationWorkflow.emptyTitle")}
        subtitle={t("miscPages.validationWorkflow.emptySubtitle")}
        action={{
          label: t("miscPages.validationWorkflow.emptyAction"),
          onClick: () => navigate("/gestion-absences"),
        }}
      />
    </div>
  );
};

export default ValidationWorkflow;
